// extracted by mini-css-extract-plugin
module.exports = {"customPath":"CustomPath_customPath__2KlfJ","input":"CustomPath_input__ARLOq","add":"CustomPath_add__36gub"};